export const siteStats = [
  { label: "收录避雷线索", value: "9,577" },
  { label: "今日新增", value: "63" },
  { label: "正在发酵话题", value: "12" },
  { label: "已澄清 / 撤稿", value: "308" },
];

export const categoryPortals = [
  {
    key: "people",
    icon: "ri-user-star-line",
    title: "风云人物 · 争议",
    blurb: "开学典礼大讲特讲的那批人，光环之下也有裂缝。",
    tag: "保研 · 评优 · 风云",
    count: "1,286",
  },
  {
    key: "avoid",
    icon: "ri-shield-check-line",
    title: "同学圈 · 避雷名单",
    blurb: "借钱、组队、恋爱前，先来查查这份口碑底账。",
    tag: "借钱 · 组队 · 恋爱",
    count: "3,412",
  },
  {
    key: "social",
    icon: "ri-flashlight-line",
    title: "社交 · 黑瓜",
    blurb: "群聊截图、饭局见闻、表白墙小作文的来龙去脉。",
    tag: "群聊 · 饭局 · 表白墙",
    count: "2,075",
  },
  {
    key: "cadre",
    icon: "ri-award-line",
    title: "学生干部 · 争议",
    blurb: "换届公示、名额分配、评优流程里的公开疑点。",
    tag: "换届 · 评优 · 公示",
    count: "896",
  },
  {
    key: "club",
    icon: "ri-group-line",
    title: "社团内部 · 瓜",
    blurb: "经费去向、内定社长、活动补贴的账到底算没算清。",
    tag: "经费 · 换届 · 内定",
    count: "1,150",
  },
  {
    key: "flip",
    icon: "ri-arrow-down-circle-line",
    title: "口碑 · 翻车现场",
    blurb: "把话说满再被打脸的全程回放，人设塌房记录。",
    tag: "打脸 · 反转 · 塌房",
    count: "758",
  },
];

export const heatTabs = [
  {
    id: "today",
    label: "今日热议",
    items: [
      {
        title: "校学生会换届名单公示后又秒删，评论区吵翻天",
        abstract: "名单刚发出就被撤回重排，有人质疑流程临场加塞。",
        tag: "换届风波",
        heat: "9.8万",
        trend: "up",
      },
      {
        title: "开学典礼主讲人「凡尔赛」发言被二传，转发破万",
        abstract: "一句不经意的话被反复剪辑，当事人连夜解释。",
        tag: "风云人物",
        heat: "8.6万",
        trend: "up",
      },
      {
        title: "某社团年费去向三年未公示，账目疑似有缺口",
        abstract: "群里催缴很积极，问明细却一直没人正面回应。",
        tag: "社团经费",
        heat: "7.9万",
        trend: "up",
      },
      {
        title: "表白墙深夜长文：被当工具人的那段经历刷屏",
        abstract: "评论区一边倒共鸣，被点名同学至今未发声。",
        tag: "人际避雷",
        heat: "6.4万",
        trend: "up",
      },
      {
        title: "奖学金公示期遭同届三次质疑名额分配",
        abstract: "综测加分项前后说法不一，评议小组发声明。",
        tag: "评优争议",
        heat: "5.2万",
        trend: "down",
      },
      {
        title: "二手群收钱不发货，投诉帖冲上同城热帖",
        abstract: "连续三个买家晒同款聊天记录，账号已注销。",
        tag: "口碑翻车",
        heat: "4.1万",
        trend: "down",
      },
    ],
  },
  {
    id: "week",
    label: "本周榜单",
    items: [
      {
        title: "学生干部「代签」考勤被点名，班群炸了",
        abstract: "代签记录与本人行程对不上，辅导员约谈中。",
        tag: "学生干部争议",
        heat: "7.4万",
        trend: "up",
      },
      {
        title: "社团换届被曝「提前定人」，普通社员才知道",
        abstract: "竞选结果与内部聊天记录高度吻合，重投呼声高。",
        tag: "社团内部瓜",
        heat: "6.8万",
        trend: "up",
      },
      {
        title: "竞赛金奖得主被队友长文复盘「功劳全揽」",
        abstract: "分工表与上台领奖名单对不上，校方介入核实。",
        tag: "风云人物",
        heat: "5.9万",
        trend: "up",
      },
      {
        title: "二手群「跑单定金」纠纷集中爆发",
        abstract: "一周内 9 例雷同话术，疑似同一人换号操作。",
        tag: "同学圈避雷",
        heat: "5.1万",
        trend: "flat",
      },
      {
        title: "食堂赞助活动补贴去向成谜，拉赞助的社干集体沉默",
        abstract: "招商海报承诺的返点始终没落地到社团账上。",
        tag: "社团经费",
        heat: "4.3万",
        trend: "down",
      },
      {
        title: "「最佳人气奖」票数被指机器灌票",
        abstract: "凌晨三点票数异常跳动，主办方称技术故障。",
        tag: "口碑翻车",
        heat: "3.7万",
        trend: "down",
      },
    ],
  },
  {
    id: "month",
    label: "本月复盘",
    items: [
      {
        title: "院级评优材料造假的完整证据链复盘",
        abstract: "从获奖证书到盖章顺序，被逐条比对出疑点。",
        tag: "评优争议",
        heat: "12.3万",
        trend: "up",
      },
      {
        title: "「保研风云人物」人设崩塌全过程时间线",
        abstract: "三年操作被扒出，当事人在官群发长文致歉。",
        tag: "风云人物",
        heat: "11.5万",
        trend: "up",
      },
      {
        title: "社团账目年度审计：多笔报销无发票留存",
        abstract: "财务离任前留下烂账，接任者公开求账本。",
        tag: "社团经费",
        heat: "9.2万",
        trend: "up",
      },
      {
        title: "学长学姐「高收益兼职」连环骗局复盘",
        abstract: "拉人头模式被拆穿，受害者自发建群维权。",
        tag: "同学圈避雷",
        heat: "8.7万",
        trend: "up",
      },
      {
        title: "学生干部微信群「顺我者昌」言论截图流出",
        abstract: "管理风格被吐槽，匿名投票压倒性要求整改。",
        tag: "学生干部争议",
        heat: "7.1万",
        trend: "down",
      },
      {
        title: "表白墙表白变致歉：一场乌龙的反转全程",
        abstract: "从甜蜜告白到认错删帖，围观群众直呼精彩。",
        tag: "社交黑瓜",
        heat: "6.0万",
        trend: "flat",
      },
    ],
  },
];

export const zonePeople = {
  title: "风云人物 · 光环之外",
  kicker: "人物争议观察",
  desc: "掌声越响的地方，越需要看清楚：荣誉是怎么来的，又是谁在托底。",
  accent: "primary",
  items: [
    {
      title: "竞赛金奖得主被指「功劳全揽」，合作队友晒分工复盘",
      abstract: "领奖台上只有一个人的名字，台下却有五个人熬的夜。",
      meta: "荣誉归属 · 3 小时前",
    },
    {
      title: "年年「优秀干部」的学长，综测加分项被逐条打问号",
      abstract: "同一个加分，自己申报一个口径、别人问起又是另一个。",
      meta: "评优流程 · 昨天",
    },
    {
      title: "迎新晚会的「社牛C位」，被扒出台下阴阳新人",
      abstract: "台上光芒万丈，后台对新人「使眼色」的那一面被拍下。",
      meta: "人设反差 · 2 天前",
    },
    {
      title: "保研经验分享被指「报喜不报忧」，信息差劝退学弟妹",
      abstract: "只讲高光不谈代价，让后来者以为这条路没有坑。",
      meta: "经验失真 · 3 天前",
    },
  ],
};

export const zoneAvoid = {
  title: "同学圈 · 避雷名单",
  kicker: "人际避雷手册",
  desc: "组队、借钱、恋爱、共事之前，先对一遍口碑，少走一点弯路。",
  accent: "secondary",
  items: [
    {
      title: "「下周一定还」的固定借主，已欠 6 人共 4 位数",
      abstract: "统一话术、统一拖延，被拆穿后换号继续。",
      meta: "借钱避雷 · 热度最高",
    },
    {
      title: "组队永远「我看看再说」，deadline 前才拉群的人",
      abstract: "划水从不迟到，收尾从不缺席，名声全靠队友口口相传。",
      meta: "组队避雷 · 3 小时前",
    },
    {
      title: "「只收钱不干活」的二手倒爷，一周 9 人踩坑",
      abstract: "商品图、收款名、发货地点三件套全程不一致。",
      meta: "交易避雷 · 昨天",
    },
    {
      title: "惯于背后传话的「热心人」，饭局话题搬运工",
      abstract: "把 A 的私事讲给 B 听，还美其名曰替你打抱不平。",
      meta: "社交避雷 · 4 天前",
    },
  ],
};

export const zoneCadre = {
  title: "学生干部 · 争议观察",
  kicker: "组织运行体检",
  desc: "换届、评优、考勤、经费，流程透明，争议自然就少一半。",
  accent: "primary",
  items: [
    {
      title: "换届名单「先定人再走流程」，普通同学最后一刻才知道",
      abstract: "公示时长被压缩到极限，反馈通道形同虚设。",
      meta: "换届流程 · 今日置顶",
    },
    {
      title: "评优名额分配三次改口径，评议小组连夜补发说明",
      abstract: "一次说按分、一次说按票、一次说按领导意见。",
      meta: "评优争议 · 昨天",
    },
    {
      title: "学生干部考勤「代签」被点名，班群当场炸锅",
      abstract: "代签记录与本人当天课程冲突，越描越黑。",
      meta: "考勤监督 · 2 天前",
    },
    {
      title: "部门经费买团建还是买设备？账目迟迟不给明细",
      abstract: "群里晒吃晒喝很积极，让拉单据就没下文。",
      meta: "经费透明 · 3 天前",
    },
  ],
};

export const zoneClub = {
  title: "社团内部 · 瓜现场",
  kicker: "社团运转内幕",
  desc: "社团好不好，看换届和账目就知道；这两样糊弄，谈什么热爱。",
  accent: "secondary",
  items: [
    {
      title: "招新海报吹的「大福利」，入社一年一件没兑现",
      abstract: "招新承诺天花乱坠，进去后发现全靠爱发电。",
      meta: "招新画饼 · 今日",
    },
    {
      title: "赞助返点去向成谜，拉赞助的社干集体沉默",
      abstract: "谈好的比例和到账的钱对不上，也没人敢问。",
      meta: "经费去向 · 昨日置顶",
    },
    {
      title: "社长被曝「口头承诺内定副社」，聊天记录石锤",
      abstract: "还没换届就先许愿，老社员表示早料到了。",
      meta: "换届内定 · 2 天前",
    },
    {
      title: "活动补贴按「亲近程度」发，关系户优先拿满额",
      abstract: "同样干活，有人全额有人垫底，落差写在脸上。",
      meta: "补贴分配 · 3 天前",
    },
  ],
};

export const zoneFlip = {
  title: "口碑翻车 · 现场回放",
  kicker: "人设塌房记录",
  desc: "把话说得太满之前，先想想后果——翻车全程都有人替你记着。",
  accent: "primary",
  items: [
    {
      title: "「我从不借钱」的励志人设，被聊天记录当场打脸",
      abstract: "前一秒立人设，下一秒旧账被翻，评论区齐喊打脸。",
      meta: "打脸现场 · 今日",
    },
    {
      title: "恋爱长文控诉前任，被反手晒出时间线反转",
      abstract: "剧情三连反转，当事人双双删帖，只留观众回味。",
      meta: "反转瓜 · 昨天",
    },
    {
      title: "吹嘘「内部消息」的百事通，消息来源被打假",
      abstract: "声称有内线，结果信息来源是公开群公告。",
      meta: "装懂翻车 · 2 天前",
    },
    {
      title: "二手好物博主被扒出货源来自拼单群",
      abstract: "人设是「自用闲置」，实为批量倒卖，粉丝直呼滤镜碎了。",
      meta: "塌房现场 · 3 天前",
    },
  ],
};

export const fermentList = [
  { name: "换届名单风波", trend: "up", delta: "+38%", heat: "12.6万" },
  { name: "竞赛功劳之争", trend: "up", delta: "+25%", heat: "9.8万" },
  { name: "社团账目缺口", trend: "up", delta: "+19%", heat: "7.4万" },
  { name: "表白墙工具人", trend: "flat", delta: "+3%", heat: "6.2万" },
  { name: "二手跑单纠纷", trend: "up", delta: "+11%", heat: "5.5万" },
  { name: "评优灌票疑云", trend: "down", delta: "-9%", heat: "3.1万" },
];

export const hotTopics = [
  "换届公示期到底该多长",
  "评优加分怎样才算透明",
  "社团账目谁来审计",
  "借钱不还怎么办",
  "组队划水避雷指南",
  "代签考勤的边界",
  "饭局话题搬运工",
  "恋爱中的人设陷阱",
  "二手交易防跑单",
  "内定与竞争怎么区分",
  "表白墙应该谁负责",
  "干部特权何时休",
  "社团经费该公开哪些",
  "高收益兼职是坑吗",
  "荣誉该不该问过程",
];

export const guardRules = [
  {
    icon: "ri-focus-3-line",
    title: "先核实，再传播",
    text: "每条线索都会交叉比对各信源，证据不全的一律标「待核实」，不标题党、不添油加醋。",
  },
  {
    icon: "ri-user-unfollow-line",
    title: "对事不对人",
    text: "我们记录的是「可核实的行为与流程争议」，拒绝人身攻击、网络暴力与无证据指控。",
  },
  {
    icon: "ri-questionnaire-line",
    title: "当事人有话说",
    text: "被提及方可通过申诉通道提交说明，核实属实的线索会同步补充或撤下，给你一个开口的位置。",
  },
  {
    icon: "ri-restart-line",
    title: "支持反转与澄清",
    text: "口碑会翻车也会翻盘。有反转、有澄清的稿件会保留完整时间线，绝不删帖息事。",
  },
];

export const hotSearchWords = [
  { rank: 1, word: "换届名单", heat: "强", up: true },
  { rank: 2, word: "社团账目", heat: "强", up: true },
  { rank: 3, word: "奖学金公示", heat: "中", up: true },
  { rank: 4, word: "二手跑单", heat: "中", up: false },
  { rank: 5, word: "干部代签", heat: "中", up: true },
  { rank: 6, word: "保研争议", heat: "中", up: false },
];